import React from "react";
// import axios from "axios";

import {
    Box,
    // IconButton,
    // Typography,
    ToggleButton,
    ToggleButtonGroup,
} from "@mui/material";

// import ListIcon from "@mui/icons-material/ViewList";
// import GridViewIcon from "@mui/icons-material/GridView";
// import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import IconLib from "./IconLib";
import { useTheme } from "../style/theme";

export default function GridListViewSelector({ view, handleViewChange }) {
    useTheme()

    const { mode } = useTheme();

    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="end"
                alignItems="end"
                gap={"1rem"}
            >
                <ToggleButtonGroup
                    value={view}
                    exclusive
                    onChange={handleViewChange}
                    aria-label="view selection"
                >
                    <ToggleButton
                        value="list"
                        aria-label="list view"
                        sx={{
                            color: "#3767B1",
                            paddingX: "1rem",
                            border: "2px solid #3B84D9",
                            borderRadius: "20rem",
                            "&.Mui-selected": {
                                color: "white",
                                backgroundColor: "#3B84D9",
                            },
                        }}
                    >
                        {view === "folder" ? (
                            <>
                                {
                                    mode === 'dark' ?
                                        <img src={IconLib.listblue} width={22} alt="" />
                                        :
                                        <img src={IconLib.listblue} width={22} alt="" />
                                }
                            </>
                        ) : (
                            <>
                                {
                                    mode === 'dark' ?
                                        <img src={IconLib.listlm} width={22} alt="" />
                                        : 
                                        <img src={IconLib.listlm} width={22} alt="" />

                                }
                            </>

                        )}


                    </ToggleButton>
                    <ToggleButton
                        value="folder"
                        aria-label="folder view"
                        sx={{
                            color: "#3767B1",
                            paddingX: "1rem",
                            border: "2px solid #3B84D9",
                            borderRadius: "20rem",
                            "&.Mui-selected": {
                                color: "white",
                                backgroundColor: "#3B84D9",
                            },
                        }}
                    >
                        {view === "folder" ? (
                            <>
                                {
                                    mode === 'dark' ?
                                        <img src={IconLib.fluentGrid28Regular} width={22} alt="" />
                                        :
                                        <img src={IconLib.fluentGrid28Regular} width={22} alt="" />
                                }
                            </>
                        ) : (

                            <>
                                {
                                    mode === 'dark' ?
                                        <img src={IconLib.fluentGrid28Regularblue} width={22} alt="" />
                                        :
                                        <img src={IconLib.fluentGrid28Regularblue} width={22} alt="" />
                                }
                            </>

                        )}
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>
        </>
    )
}
